export default class HotelTypeServiceSection extends HTMLElement {
    constructor() {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.backgroundImage = this.getAttribute('background-image');
    }

    static get observedAttributes() {
        return ['stylesheet', "background-image", "collapse-section"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.shadowRoot) {
            if (this.shadowRoot.querySelector(`[name="${name}"]`)) {
                this.shadowRoot.querySelector(`[name="${name}"]`).innerHTML = this[name];
            }
        }
    }

    connectedCallback() {
        let shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#hotel-type-service-section');
        const instance = t.content.cloneNode(true);

        if (this.stylesheet !== undefined) {
            this._appendChild(instance);

            shadowRoot.appendChild(instance);
        }

        return shadowRoot;
    }

    _appendChild(instance) {
        if (this.backgroundImage !== undefined && this.backgroundImage != null) {
            instance.querySelector('[name="container"]').style.backgroundImage =
                `url('${this.backgroundImage}')`;
        }

        instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = "";
        });
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
    }
}
